import { useState } from "react";

function Content(props) {
    const [className, setClassName] = useState("content " + props.className);

    return (
        <div className={className}>{props.children}</div>    
    );
}

export default Content;
